/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class InstanceGrid extends SiteEntityGrid<InstanceRow, any> {
        protected getColumnsKey() { return 'Data.Instance'; }
        protected getDialogType() { return InstanceDialog; }
        protected getIdProperty() { return InstanceRow.idProperty; }
        protected getLocalTextPrefix() { return InstanceRow.localTextPrefix; }
        protected getService() { return InstanceService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}